import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import Area from '@/components/apps/layouts/shared/Area';
import { AniSlideUp } from '@/components/shared/animations/basic';

import IndustrialFasteningMetrics from './IndustrialFasteningMetrics';
import IndustrialFasteningPoints from './IndustrialFasteningPoints';

/**
 * ### IndustrialFasteningSection
 *
 * Reads the first production use case — connector engagement — in full, as one
 * sub-block under the page's own sections rather than as another of them.
 *
 * It is deliberately quieter than the sections around it: no `SectionTitle`,
 * an eyebrow instead of a section heading, headings one level down, and a
 * bounded surface holding both parts together. A reader scanning section
 * headings sees the three use cases and the three production figures; only a
 * reader who stops on fastening reads this.
 *
 * @returns The rendered fastening deep-dive element
 * @see {@link IndustrialFasteningPoints} The defects it catches
 * @see {@link IndustrialFasteningMetrics} The published figures for it
 */
export default function IndustrialFasteningSection() {
  const { t } = useTranslation('common');

  return (
    <section
      className="bg-apps-brandGrayBlack pt-[clamp(60px,6.25vw,120px)]"
      data-analytics-section="fastening_inspection"
    >
      <Area>
        <AniSlideUp>
          <div className="rounded-[20px] border border-[rgba(255,255,255,0.12)] bg-[rgba(255,255,255,0.03)] p-[24px] lg:rounded-[28px] lg:p-[clamp(32px,3.333vw,56px)]">
            <p className="inline-flex rounded-full bg-[rgba(255,255,255,0.08)] px-[14px] py-[6px] text-[13px] font-bold leading-[140%] tracking-[-0.26px] text-apps-brandGray900 lg:text-[14px]">
              {t('체결 검사 자세히 보기')}
            </p>
            <div className="mt-[24px] flex flex-col gap-[40px] lg:mt-[32px] lg:gap-[56px]">
              <IndustrialFasteningPoints />
              <IndustrialFasteningMetrics />
            </div>
          </div>
        </AniSlideUp>
      </Area>
    </section>
  );
}
